import { FC } from 'react';
import { ClaimsLayout } from 'pages/atoms';
import { ClaimsList } from 'containers/claims';

const ClaimsPage: FC = () => {
  return (
    <ClaimsLayout>
      <ClaimsList />
    </ClaimsLayout>
  );
};

export default ClaimsPage;
